// components
import ProgressBar from 'react-bootstrap/ProgressBar';
import { useContext, useEffect, useState } from 'react';
// contexts
import { Text } from '../../contexts/textContext/textContext';
import { ThemeData } from '../../contexts/themeContext/themeContext';

export default function LetterCounts() {
    const text = useContext(Text);
    const theme = useContext(ThemeData);
    const [letterCount, setLetterCount] = useState({});

    // this use effect is for letter counting
    useEffect(() => {
        if (text) {
            const counts = {};
            for (let letter of text) {
                counts[letter] = (counts[letter] || 0) + 1;
            }
            setLetterCount(counts);
        }
    }, [text]);

    function letterPercentage() {

        // function for letter tag
        function letterTag(letter) {
            let char;
            switch (letter) {
                case ' ':
                    char = 'White Space';
                    break;
                case '\n':
                    char = 'New Line Char';
                    break;
                default: char = letter;
                    break;
            }
            return char.toUpperCase();;
        }

        // sorting letter Count's
        const sortedEntries = Object.entries(letterCount).sort((a, b) => b[1] - a[1]);
        const sortedObj = Object.fromEntries(sortedEntries);
        return (
            Object.keys(sortedObj).map(letter =>
                <div className='my-3'>
                    <div className='d-flex justify-content-between'>
                        <div>
                            {letterTag(letter)}
                        </div>
                        <div>
                            <span className='me-1'>
                                {letterCount[letter]}
                            </span>
                            <span>
                                ({parseInt(letterCount[letter] / text.length * 100)}%)
                            </span>
                        </div>
                    </div>
                    <div><ProgressBar variant={`${theme === 'dark' ? 'light' : 'dark'}`} now={letterCount[letter] / text.length * 100} /></div>
                </div>
            )
        );
    }

    return (
        <div className='my-5'>
            <div>
                <h3>
                    Letter Density
                </h3>
            </div>
            {
                text &&
                <div>
                    {
                        letterPercentage()
                    }
                </div>
            }
        </div>
    );
}